<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
	  
	  <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
		  <el-form-item>
			  <el-date-picker v-model="orderquery.date" type="daterange" style="width:100%"
				  range-separator="至"
				  start-placeholder="开始日期"
				  end-placeholder="结束日期"
			      value-format="yyyy-MM-dd" :unlink-panels="false" @change="orderquery.ischange=true">
			  </el-date-picker>
		  </el-form-item>
		  <el-form-item style="width:11%">
			  <el-select v-model="orderquery.status" placeholder="订单状态" filterable clearable @change="orderquery.ischange=true">
				  <el-option v-for="(item,index) in orderstatus" :label="item.name" :value="item.id" :key="index"></el-option>
			  </el-select>
		  </el-form-item>
		  <el-form-item>
              <el-input placeholder="请输入拼多多订单号 / 成交店铺 / 买家昵称 / 收货人姓名 / 收货人电话" v-model="orderquery.key" clearable @keyup.enter.native="getTmalllists" @change="orderquery.ischange=true" style="width:100%"></el-input>
          </el-form-item>
		  <el-form-item>
              <el-button type="warning" size="small" round @click="getorderlists">查询</el-button>
			  <el-tooltip class="item" effect="dark" content="从拼多多后台批量导出订单数据，并导入宠赞" placement="top-start">
			  <el-button type="warning" size="small" round @click="exportorders">批量导入</el-button>
			  </el-tooltip>
			  <el-button type="warning" size="small" round @click="sysnpinddorders">同步拼多多订单</el-button>
			  <input type="file" id="orderfile" @change="getorderfiles(this)" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style="display:none" title="1" />
          </el-form-item>
	  </el-form>

	  <div class="backborder2" style="margin-top:10px">
	  	  <el-table :data="orderlists" style="width:100%" v-loading="orderquery.loading">
			  <el-table-column type="expand">
				  <template slot-scope="props">
					  <div class="cz-pindd-address">收货信息：{{props.row.reciever_name}}，{{props.row.receiver_phone}}，{{props.row.receiver_address}}</div>
					  <div class="cz-pindd-address" style="width:100%;margin-bottom:10px;">备注：{{props.row.buyer_message}}</div>

					  <el-table :data="props.row.goods">

                            <el-table-column label="商品名称" min-width="400px">
                                <template slot-scope="goodsinfos">
                                    <div class="tmall-order-goods">
                                        <div class="tmall-order-goods-img">
                                            <span class="tmall-order-goods-gift" v-if="goodsinfos.row.type==2">赠</span>
                                            <img :src="goodsinfos.row.img ? goodsinfos.row.img : require('../../assets/img-default.png')" />
										</div>
                                        <div class="tmall-order-goods-name" style="margin-left:10px;">
											<div>{{goodsinfos.row.pindd_name}} 【{{goodsinfos.row.pindd_spec}}】</div>
											<div class="tmall-order-goods-spec">skuid：{{goodsinfos.row.pindd_skuid}}</div>
										</div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="价格" min-width="120" align="center">
                                <template slot-scope="goodsinfos">
                                    <div style="float:left;width:100%">{{goodsinfos.row.price}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" min-width="120" align="center">
                                <template slot-scope="goodsinfos">
                                    <div style="float:left;width:100%">{{goodsinfos.row.num}}</div>
                                </template>
                            </el-table-column>
							<el-table-column label="订单金额" min-width="120" align="center">
                                <template slot-scope="goodsinfos">
                                    <div style="float:left;width:100%">{{goodsinfos.row.total}}</div>
                                </template>
                            </el-table-column>
							<el-table-column label="店铺优惠" min-width="120" align="center">
                                <template slot-scope="goodsinfos">
                                    <div style="float:left;width:100%">{{goodsinfos.row.shop_derate}}</div>
                                </template>
                            </el-table-column>
							<el-table-column label="平台优惠" min-width="120" align="center">
                                <template slot-scope="goodsinfos">
                                    <div style="float:left;width:100%">{{goodsinfos.row.mall_derate}}</div>
                                </template>
                            </el-table-column>
							<el-table-column label="用户实付" min-width="120" align="center">
                                <template slot-scope="goodsinfos">
                                    <div style="float:left;width:100%">{{goodsinfos.row.member_price}}</div>
                                </template>
                            </el-table-column>
							<el-table-column label="商家实收" min-width="120" align="center">
                                <template slot-scope="goodsinfos">
                                    <div style="float:left;width:100%">{{goodsinfos.row.bussiness_price}}</div>
                                </template>
                            </el-table-column>
                      </el-table>
				  </template>
			  </el-table-column>

			  <el-table-column label="ID" min-width="100px" align="center">
                  <template slot-scope="props">
                      <div class="cz-pindd-order-infos-style2">{{props.row.id}}</div>
              	  </template>
              </el-table-column>
			  <el-table-column label="授权店铺" min-width="150px" align="left">
                  <template slot-scope="props">
                      <div class="cz-pindd-order-infos-style2">{{props.row.shopname}}</div>
              	  </template>
              </el-table-column>
			  <el-table-column label="拼多多订单" align="left" min-width="250px">
                  <template slot-scope="props">
                      <div class="cz-pindd-order-infos-style2" style="display:flex;align-items:center;">
					  	 {{props.row.trade_sn}}
						 <el-tooltip class="item" effect="dark" content="已支付" placement="top-start">
						 <img src="@/assets/Goods/ispay.png" style="width:20px;height:20px;margin-left:5px"/>
						 </el-tooltip>
					  </div>
              	  </template>
              </el-table-column>
			  <el-table-column label="订单金额" align="center" min-width="100px">
                  <template slot-scope="props">
                      <div class="cz-pindd-order-infos-style2">{{props.row.order_price}}</div>
              	  </template>
              </el-table-column>
			  <el-table-column label="店铺优惠" align="center" min-width="100px">
                  <template slot-scope="props">
                      <div class="cz-pindd-order-infos-style2">{{props.row.shop_derate}}</div>
              	  </template>
              </el-table-column>
			  <el-table-column label="平台优惠" align="center" min-width="100px">
                  <template slot-scope="props">
                      <div class="cz-pindd-order-infos-style2">{{props.row.mall_derate}}</div>
              	  </template>
              </el-table-column>
			  <el-table-column label="用户实付" align="center" min-width="100px">
                  <template slot-scope="props">
                      <div class="cz-pindd-order-infos-style2">{{props.row.member_price}}</div>
              	  </template>
              </el-table-column>
			  <el-table-column label="平台实收" align="center" min-width="100px">
                  <template slot-scope="props">
                      <div class="cz-pindd-order-infos-style2">{{props.row.bussiness_price}}</div>
              	  </template>
              </el-table-column>
			  <el-table-column label="支付时间" align="center" min-width="140px">
                  <template slot-scope="props">
                      <div class="cz-pindd-order-infos-style2">{{props.row.pay_time}}</div>
              	  </template>
              </el-table-column>
			  <el-table-column label="操作" align="center" min-width="350px" fixed="right">
				  <template slot-scope="props">
					  <el-tooltip class="item" effect="dark" content="刷新当前拼多多订单信息" placement="top-start">
					  <el-button type="warning" size="small" round @click="freshorder(props.row)">刷新订单</el-button>
				  	  </el-tooltip>

				  	  <el-tooltip class="item" effect="dark" content="生成线下销售出库单" placement="top-start">
					  <el-button type="warning" v-if="props.row.issell==0" size="small" round @click="createSell(props.row)">生成出库单</el-button>
				  	  </el-tooltip>

					  <el-tooltip class="item" effect="dark" content="查看拼多多订单生成对应的销售出库单" placement="top-start">
					  <el-button type="" size="small" round v-if="props.row.issell==1" @click="checksell(props.row)">查看出库单</el-button>
					  </el-tooltip>
					  
					  <el-tooltip class="item" effect="dark" content="将当前订单物流信息同步至拼多多" placement="top-start">
					  <el-button type="warning" v-if="props.row.issysnshipping==0" size="small" round @click="synshippings(props.row)">同步物流信息</el-button>
				  	  </el-tooltip>

					  <el-tooltip class="item" effect="dark" content="查看订单物流信息" placement="top-start">
					  <el-button type="" size="small" round v-if="props.row.issysnshipping==1" @click="checkshipping(props.row)">查看物流</el-button>
					  </el-tooltip>
				  </template>
			  </el-table-column>
		  </el-table>
	  </div>

	
	  <!-- 上传订单信息 -->
	  <el-dialog title="上传订单信息详情" :visible.sync="uploadfile.dialog" width="73%" top="10vh">
		  <div class="pindd-orders-upload-title">当前有 <span>{{uploadfile.data.length}}</span> 个订单正在等待上传，</div>
		  <el-button type="warning" size="small" round @click="exportorders">重新上传</el-button>
		  <el-button type="warning" size="small" round @click="saveorders" style="float:right">提 交</el-button>
		  <el-button type="" size="small" round @click="uploadfile.dialog=false" style="float:right">取 消</el-button>
		  <el-table :data="uploadfile.data" style="width:100%;margin-top:20px" v-loading="uploadfile.loading">
				
				<el-table-column type="expand">
					<template slot-scope="props">
						<el-table :data="props.row.goods">
								<el-table-column label="id" width="100" align="center">
									<template slot-scope="goodsinfos">
										<div style="float:left;width:100%;font-size:13px;">{{goodsinfos.row.id}}</div>
									</template>
								</el-table-column>
								<el-table-column label="商品名称" min-width="300px">
									<template slot-scope="goodsinfos">
										<div class="tmall-order-goods">
											<div class="tmall-order-goods-name">{{goodsinfos.row.name}}</div>
											<div class="tmall-order-goods-spec">规格：{{goodsinfos.row.spec}}</div>
										</div>
									</template>
								</el-table-column>
								<el-table-column label="价格" min-width="120" align="center">
									<template slot-scope="goodsinfos">
										<div style="float:left;width:100%;font-size:13px;">{{goodsinfos.row.price}}</div>
									</template>
								</el-table-column>
								<el-table-column label="数量" min-width="120" align="center">
									<template slot-scope="goodsinfos">
										<div style="float:left;width:100%;font-size:13px;">{{goodsinfos.row.num}}</div>
									</template>
								</el-table-column>
								<el-table-column label="小计" min-width="120" align="center">
									<template slot-scope="goodsinfos">
										<div style="float:left;width:100%;font-size:13px;">{{goodsinfos.row.total}}</div>
									</template>
								</el-table-column>
								<el-table-column label="店铺优惠" min-width="120" align="center">
									<template slot-scope="goodsinfos">
										<div style="float:left;width:100%;font-size:13px;">{{goodsinfos.row.shop_derate}}</div>
									</template>
								</el-table-column>
								<el-table-column label="平台优惠" min-width="120" align="center">
									<template slot-scope="goodsinfos">
										<div style="float:left;width:100%;font-size:13px;">{{goodsinfos.row.mall_derate}}</div>
									</template>
								</el-table-column>
								<el-table-column label="用户实付" min-width="120" align="center">
									<template slot-scope="goodsinfos">
										<div style="float:left;width:100%;font-size:13px;">{{goodsinfos.row.member_price}}</div>
									</template>
								</el-table-column>
								<el-table-column label="商家实收" min-width="120" align="center">
									<template slot-scope="goodsinfos">
										<div style="float:left;width:100%;font-size:13px;">{{goodsinfos.row.bussiness_price}}</div>
									</template>
								</el-table-column>
						</el-table>
					</template>
				</el-table-column>
				
				<el-table-column label="订单号" align="center" min-width="140px">
					<template slot-scope="props">
						<div class="cz-pindd-order-infos-style2" style="font-size:13px;">{{props.row.order_sn}}</div>
					</template>
              	</el-table-column>
				<el-table-column label="订单状态" align="center" min-width="140px">
					<template slot-scope="props">
						<div class="cz-pindd-order-infos-style2" style="font-size:13px;">{{props.row.order_status}}</div>
					</template>
              	</el-table-column>
				<el-table-column label="订单金额" align="center" min-width="140px">
					<template slot-scope="props">
						<div class="cz-pindd-order-infos-style2" style="font-size:13px;">{{props.row.order_price}}</div>
					</template>
              	</el-table-column>
				<el-table-column label="店铺优惠金额" align="center" min-width="140px">
					<template slot-scope="props">
						<div class="cz-pindd-order-infos-style2" style="font-size:13px;">{{props.row.shop_derate}}</div>
					</template>
              	</el-table-column>
				<el-table-column label="平台优惠金额" align="center" min-width="140px">
					<template slot-scope="props">
						<div class="cz-pindd-order-infos-style2" style="font-size:13px;">{{props.row.mall_derate}}</div>
					</template>
              	</el-table-column>
				<el-table-column label="用户实付金额" align="center" min-width="140px">
					<template slot-scope="props">
						<div class="cz-pindd-order-infos-style2" style="font-size:13px;">{{props.row.member_price}}</div>
					</template>
              	</el-table-column>
				<el-table-column label="商家实收金额" align="center" min-width="140px">
					<template slot-scope="props">
						<div class="cz-pindd-order-infos-style2" style="font-size:13px;">{{props.row.bussiness_price}}</div>
					</template>
              	</el-table-column>
		  </el-table>
		  <div class="pindd-orders-upload-title" style="margin-top:20px;">当前有 <span>{{uploadfile.data.length}}</span> 个订单正在等待上传，</div>
		  <el-button type="warning" size="small" round @click="exportorders">重新上传</el-button>
		  <el-button type="warning" size="small" round @click="saveorders" style="float:right;margin-top:20px;">提 交</el-button>
		  <el-button type="" size="small" round @click="uploadfile.dialog=false" style="float:right;margin-top:20px;">取 消</el-button>
	  </el-dialog>

	  <!-- 上传订单等待 -->
	  <el-dialog title="等待加载动画" :visible.sync="uploadanimote.view" width="35%" top="25vh">
			<el-progress :percentage="uploadanimote.percent"  color="#e6a23c" />
	  </el-dialog>
	  <!-- 上传订单等待 -->


	  <!-- 查看销售出库单 -->
	  <el-dialog title="查看销售出库单" :visible.sync="sellinfos.view" width="65%" top="10vh">
	  	  <div v-if="!sellinfos.lists" class="cz-pindd-sell-show"><img src="@/assets/shipping_gray.png"><span>暂无销售出库单</span></div>
		  <div v-if="sellinfos.lists" v-loading="sellinfos.loading">
		  	  <span class="cz-pindd-sell-documents">出库单号：{{sellinfos.lists.documents}}</span>
			  <el-table :data="sellinfos.lists.goods" style="margin-top:20px">
				  <el-table-column label="商品" align="left" min-width="320px">
					  <template slot-scope="props">
						  <div class="cz-pindd-order-infos-style2" style="font-size:13px;">{{props.row.name}}</div>
						  <div class="cz-pindd-order-infos-style2" style="font-size:12px;color:#999999">编号：{{props.row.number}}</div>
					  </template>
              	  </el-table-column>
				  <el-table-column label="价格" align="center" min-width="110px">
					  <template slot-scope="props">
						  <div class="cz-pindd-order-infos-style2" style="font-size:13px;">{{props.row.dis_sell}}</div>
					  </template>
              	  </el-table-column>
				  <el-table-column label="数量" align="center" min-width="110px">
					  <template slot-scope="props">
						  <div class="cz-pindd-order-infos-style2" style="font-size:13px;">{{props.row.num}}</div>
					  </template>
              	  </el-table-column>
				  <el-table-column label="小计" align="center" min-width="110px">
					  <template slot-scope="props">
						  <div class="cz-pindd-order-infos-style2" style="font-size:13px;">{{props.row.total}}</div>
					  </template>
              	  </el-table-column>
				  <el-table-column label="类型" align="center" min-width="110px">
					  <template slot-scope="props">
						  <div class="cz-pindd-order-infos-style2" style="font-size:13px;">{{props.row.type}}</div>
					  </template>
              	  </el-table-column>
			  </el-table>
		  </div> 
	  </el-dialog>


	  <!-- 查看快递信息 -->
      <el-dialog title="查看快递信息" :visible.sync="shippinglists.dialog" top="10vh" width="70%" height="100%" :beforeClose="closemyshipping">
          <Showshipping  v-model="shippinglists.orderid" :ordertype="shippinglists.type" @finish="closemyshippingDialog"/>
      </el-dialog>

	  <!-- 选择同步店铺 -->
	  <el-dialog title="选择待同步的店铺" :visible.sync="authshopdialog" top="10vh" width="30%">
		  <el-select v-model="authshopid" placeholder="请选择店铺信息" filterable clearable size="small">
			  <el-option v-for="(item,index) in authshoplists" :label="item.name+'（'+item.owner_id+'）'" :value="item.id" :key="index"></el-option>
		  </el-select>
		  <div slot="footer" class="dialog-footer">
	          <el-button size="small" @click="authshopdialog = false">取 消</el-button>
	          <el-button size="small" type="primary" @click="sysorderdetails">同步</el-button>
	      </div>	     
	  </el-dialog>


    
  </div>
  </transition>
</template>

<script>
import Showshipping from '@/components/mall/shipping/showshipping' //查看快递信息
export default {
  components: {Showshipping},
  data () {
    return {
      url:this.GLOBAL.domain+"Pindd/index",
      transitionshow:true,
      actionauth:[],
	  orderquery: {
		  act:'getorderlists',
		  token:this.$cookies.get('token'),
		  timetype:1,
		  date:[],
		  status:'',
		  key:'',
		  p:1,
		  rollpage:10,
		  loading:false,
		  ischange:false,
		  row:'',
	  },
	  timetypelists:[{id:1,name:'订单创建时间'},{id:2,name:'订单支付时间'}],
	  orderstatus:[
          {id:1,name:'待发货'},
          {id:2,name:'已发货待签收'},
          {id:3,name:'已签收'},
      ],
	  
	  uploadfile: {
		  dialog:false,
		  loading:false,
		  data:[],
	  },
	  
	  uploadobj:null,
	  uploadanimote: {
		  view:false,
		  frequency:'', //次数
		  localnum:'',  //当前次数
		  percent:'',   //当前进度条百分比
		  isdraf:false, //是否停止提交，提交正在进行
		  data:[],
	  },

	  orderlists:[
		  {
			  id:8888,trade_sn:'PDD019238475843378',pindd_settingname:'小七高端宠物用品',
			  status:'已支付',createtime:'2022-07-21 14:22',pay_time:'2022-07-21 14:22',
			  order_price:1750.00,shop_derate:0,mall_derate:0,member_price:1750.00,bussiness_price:1750.00,
			  buyer_message:'剑气纵横三万里',reciever_name:'李二狗',receiver_phone:'18190998766',city:'广西省-南宁市-青秀区',
			  address:'太平洋世纪广场A座1902',issysnshipping:0,issell:0,
			  goods:[
				  {id:1,pindd_skuid:'223432112',pindd_name:'信社电器无线吸尘器家用大吸力手持式小型强力除螨拖地一体机',pindd_spec:'A5C',img:'',price:50.00,num:5,total:250.00,shop_derate:0,mall_derate:0,member_price:250,bussiness_price:250,type:1},
				  {id:2,pindd_skuid:'223432112',pindd_name:'信社电器无线吸尘器家用大吸力手持式小型强力除螨拖地一体机',pindd_spec:'A5C',img:'',price:50.00,num:5,total:250.00,shop_derate:0,mall_derate:0,member_price:250,bussiness_price:250,type:2},
				  {id:3,pindd_skuid:'223432112',pindd_name:'信社电器无线吸尘器家用大吸力手持式小型强力除螨拖地一体机',pindd_spec:'A5C',img:'',price:50.00,num:5,total:250.00,shop_derate:0,mall_derate:0,member_price:250,bussiness_price:250,type:1},
				  {id:4,pindd_skuid:'223432112',pindd_name:'信社电器无线吸尘器家用大吸力手持式小型强力除螨拖地一体机',pindd_spec:'A5C',img:'',price:50.00,num:5,total:250.00,shop_derate:0,mall_derate:0,member_price:250,bussiness_price:250,type:1},
				  {id:5,pindd_skuid:'223432112',pindd_name:'信社电器无线吸尘器家用大吸力手持式小型强力除螨拖地一体机',pindd_spec:'A5C',img:'',price:50.00,num:5,total:250.00,shop_derate:0,mall_derate:0,member_price:250,bussiness_price:250,type:2},
				  {id:6,pindd_skuid:'223432112',pindd_name:'信社电器无线吸尘器家用大吸力手持式小型强力除螨拖地一体机',pindd_spec:'A5C',img:'',price:50.00,num:5,total:250.00,shop_derate:0,mall_derate:0,member_price:250,bussiness_price:250,type:1},
				  {id:7,pindd_skuid:'223432112',pindd_name:'信社电器无线吸尘器家用大吸力手持式小型强力除螨拖地一体机',pindd_spec:'A5C',img:'',price:50.00,num:5,total:250.00,shop_derate:0,mall_derate:0,member_price:250,bussiness_price:250,type:2},
			  ]
		  },
	  ],

	  sellinfos:{
		  act:'getsells',
		  token:this.$cookies.get('token'),
		  view:false,
		  loading:false,
		  id:'',
		  lists:{}
	  },

	  shippinglists:{
		  dialog:false,
		  orderid:'',
		  type:'pindd',
	  },	  

	  authshoplists:[],	
	  authshopdialog:false,
	  authshopid:'',
	  authloading:'',

      
    }
  },
  
  
  mounted(){
      //this.getactionauth(); //获取权限设置
	  this.getorderlists(); //获取订单列表
	  this.getauthshopnums(); //获取授权店铺数量
  },
  
  methods:{


	  //同步拼多多订单信息到本地
	  sysnpinddorders() {
		  if(this.authshoplists.length==0) {this.$message.error('当前没有授权店铺，请前往拼多多店铺配置里添加');return false;}
		  if(this.authshoplists.length==1) {
			  this.authshopid=this.authshoplists[0].id;
			  this.sysorderdetails();
		  }
		  if(this.authshoplists.length > 1) {
			  this.authshopdialog=true;
			  this.authshopid='';
		  } 
	  },


	  //同步拼多多订单信息
	  sysorderdetails() {
		  if(this.authshopid=='') {this.$message.error('请选择要同步的授权店铺');return false;}
		
		  //添加加载动画
		  this.authloading=this.$loading({
			  lock: true,
			  text: '订单同步中...',
			  spinner: 'el-icon-loading',
			  background: 'rgba(0, 0, 0, 0.8)'
		  });	
		  

		  //后台操作同步数据
		  var resource = this.$resource(this.url);
		  resource.save({act:'sys_pindd_order_from_handle',token:this.$cookies.get('token'),settingid:this.authshopid}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
				  alert(res.data.Message);
				  //关闭动画
		  		  this.authloading.close();

			  }else{
				  //关闭动画
		  		  this.authloading.close();
				  this.authshopdialog=false;
				  this.getorderlists();
			  }
	      }).catch((res) => {
			  //关闭动画
		  	  this.authloading.close();
	      });
	  },



	  //获取授权店铺数量
	  getauthshopnums() {
		  var resource = this.$resource(this.url);
		  resource.save({act:'getauthshops',token:this.$cookies.get('token')}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
			  }else{
				  this.authshoplists=JSON.parse(Base64.decode(res.data.Data));
			  }
	      }).catch((res) => {
	          
	      });
	  },

	  
	  //获取物流信息
	  checkshipping(item) {
		  this.shippinglists.dialog=true;
		  this.shippinglists.orderid=item.id;
	  },

	  closemyshippingDialog() {
		  this.shippinglists.orderid='';
		  this.shippinglists.dialog=false;
	  },

	  closemyshipping() {
		  this.shippinglists.orderid='';
		  this.shippinglists.dialog=false;
	  },


	  //查看销售出库单
	  checksell(item) {
		  this.sellinfos.view=true;
		  this.sellinfos.loading=true;
		  this.sellinfos.id=item.id;
		  this.sellinfos.lists={};

		  var resource = this.$resource(this.url);
		  resource.save(this.sellinfos).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
				  this.sellinfos.loading=false;
			  }else{
				  this.sellinfos.lists=JSON.parse(Base64.decode(res.data.Data));
				  this.sellinfos.loading=false;
				  if(!this.sellinfos.lists.documents) this.sellinfos.lists=null;
				  console.log(this.sellinfos.lists);
			  }
	      }).catch((res) => {
	          this.sellinfos.loading=false;
	      });
	  },


	  //同步物流信息
	  synshippings(item) {
		  var resource = this.$resource(this.url);
		  resource.save({act:'sysshipping',token:this.$cookies.get('token'),id:item.id}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
			  }else{
				  this.getorderlists();
			  }
	      }).catch((res) => {
	          
	      });
	  },


	  //生成线下销售出库单
	  createSell(item) {
		  var resource = this.$resource(this.url);
		  resource.save({act:'pinddcreatesell',token:this.$cookies.get('token'),id:item.id}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
			  }else{
				  this.getorderlists();
			  }
	      }).catch((res) => {
	          
	      });
	  },

	  //刷新当前拼多多订单信息
	  freshorder(item) {
		  var resource = this.$resource(this.url);
		  resource.save({act:'freshpinddorders',token:this.$cookies.get('token'),id:item.id}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
			  }else{
				  this.getorderlists();
			  }
	      }).catch((res) => {
	          
	      });
	  },


	  //获取订单信息列表
	  getorderlists() {
		  if(this.orderquery.ischange) {
			  this.orderquery.p=1;
			  this.orderquery.rollpage=10;
			  this.orderquery.ischange=false;
		  }

		  this.orderquery.loading=true;
		  var resource = this.$resource(this.url);
	      resource.save(this.orderquery).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
				  this.orderquery.loading=false;

			  }else{
				  this.orderlists=JSON.parse(Base64.decode(res.data.Data));
				  console.log(this.orderlists[0].goods);
				  this.orderquery.row=parseInt(res.data.count);
				  this.orderquery.loading=false;
			  }
	      }).catch((res) => {
	          this.orderquery.loading=false;
	      });

	  },
	

	  //////////////////////////////////////////////////////////////////////////
	  //批量导入订单到本地

	  //批量导入订单信息
	  exportorders() {
		  document.getElementById("orderfile").click();
	  },

	  //导入商品订单信息
	  getorderfiles(obj) {
		  this.uploadfile.dialog=true;
		  this.uploadfile.loading=true;
		  this.uploadfile.data=[];
		  
		  //提取订单信息
		  let templists={};
		  let _this = this;
		  let outdata = [];
          let inputDOM = this.$refs.inputer;

		  // 通过DOM取文件数据
          this.file = event.currentTarget.files[0];                
          var rABS = false; //是否将文件读取为二进制字符串
          var f = this.file;
          var reader = new FileReader();
          FileReader.prototype.readAsBinaryString = function(f) {
            var binary = "";
            var rABS = false; //是否将文件读取为二进制字符串
            var pt = this;
            var wb; //读取完成的数据
            var reader = new FileReader();
            reader.onload = function(e) {
            	var bytes = new Uint8Array(reader.result);
                var length = bytes.byteLength;
                for(var i = 0; i < length; i++) binary += String.fromCharCode(bytes[i]);
                	var XLSX = require('xlsx');
                if(rABS) {
                	wb = XLSX.read(btoa(fixdata(binary)), {type:'base64'});
                }else {
                    wb = XLSX.read(binary, {type: 'binary'});
                }

                outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);//outdata就是你想要的东西
                outdata.forEach(function(item,index) {
				   let order_sn=item['订单号'];
				   templists[order_sn] ? '' : templists[order_sn]={};

                   templists[order_sn].order_sn=order_sn;											   								   		  //订单号
				   templists[order_sn].order_status=item['订单状态']; 																   		   //状态
				   templists[order_sn].order_price
				   =parseFloat(templists[order_sn].order_price ? templists[order_sn].order_price : 0) + parseFloat(item['商品总价(元)']); 	   //订单金额小计

				   templists[order_sn].shop_derate
				   =parseFloat(templists[order_sn].shop_derate ? templists[order_sn].shop_derate : 0) + parseFloat(item['店铺优惠折扣(元)']); //店铺优惠折扣(元)

				   templists[order_sn].mall_derate
				   =parseFloat(templists[order_sn].mall_derate ? templists[order_sn].mall_derate : 0) + parseFloat(item['平台优惠折扣(元)']); //平台优惠折扣(元)

				   templists[order_sn].member_price
				   =parseFloat(templists[order_sn].member_price ? templists[order_sn].member_price : 0) + parseFloat(item['用户实付金额(元)']); //用户实付金额(元)

				   templists[order_sn].bussiness_price
				   =parseFloat(templists[order_sn].bussiness_price ? templists[order_sn].bussiness_price : 0) + parseFloat(item['商家实收金额(元)']); //商家实收金额(元)

				   templists[order_sn].goods ? '' : templists[order_sn].goods=[];	
				   templists[order_sn].goods.push({ //订单商品信息
						id:item['商品id'],
						name:item['商品'],
						spec:item['商品规格'],
						price:parseFloat(item['商品总价(元)']) / parseFloat(item['商品数量(件)']),
						num:item['商品数量(件)'],
						total:item['商品总价(元)'],
						shop_derate:item['店铺优惠折扣(元)'],
						mall_derate:item['平台优惠折扣(元)'],
						member_price:item['用户实付金额(元)'],
						bussiness_price:item['商家实收金额(元)'],
				   });
                });

				for(var tt in templists) {
					_this.uploadfile.data.push(templists[tt]);
				}
				console.log(templists);

                //清空输入框的文件值，避免下次change事件失效
                document.getElementById('orderfile').value = null;     
                _this.uploadfile.loading=false;      
            }
            reader.readAsArrayBuffer(f);
          }

          if(rABS) {
        	  reader.readAsArrayBuffer(f);
          } else {
              reader.readAsBinaryString(f);
          }    
	  },


	  //提交保存订单信息
	  saveorders() {
		  if(this.uploadfile.data.length==0) {this.$message.error('请上传要提交的拼多多订单');return false;}

		  //数据分段折叠打包传输
		  let frequency; 
		  let lastfrequency;
		  let allnums=this.uploadfile.data.length; //总订单数
		  let number=15; //每次传输30个订单

		  //初始化进度条信息
		  this.uploadanimote.view=true;
		  this.uploadanimote.frequency='';
		  this.uploadanimote.localnum='';
		  this.uploadanimote.percent=0;
		  this.uploadanimote.isdraf=false;

		  //分段组装参数（一次提交多个订单信息）
		  this.uploadanimote.data=[];
		  let ii;
		  let _this=this;
		  this.uploadfile.data.forEach(function(item,index) {
			  frequency=parseInt(index / number);
		  	  lastfrequency=parseInt(allnums % number);

			  if(frequency==0 && lastfrequency==0) {
				  ii=0;
			  }else if(frequency > 0 && lastfrequency==0) {
				  ii=parseInt(frequency) - parseInt(1);
			  }else {
				  ii=frequency;
			  }

			  _this.uploadanimote.data[ii] ? '' : _this.uploadanimote.data[ii]=[];
			  _this.uploadanimote.data[ii].push(item);
		  });

		  //开启数据提交
		  this.uploadobj=setInterval(this.synorderlists,5000); //打开定时器
		  //this.synorderlists();
	  },


	  //同步订单数据到服务器
	  synorderlists() {
		  if(this.uploadanimote.isdraf) return false; //如有正在执行的任务则不往下执行
		  this.uploadanimote.isdraf=true;

		  //取出一个要上传的数据
		  let postdata=[];
		  this.uploadanimote.data.forEach(function(item,index) {
			  if(!item.ishandle) {postdata=item;return false;}
		  });

		  //上传订单数据到后台
		  var resource = this.$resource(this.url);
	      resource.save({act:'savepddorder',token:this.$cookies.get('token'),orders:JSON.stringify(postdata)}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);

				  
				  postdata.ishandle=true; //标记上传完成
				  //获取处理的数据结果 
				  this.getsynresult();
				  this.uploadanimote.isdraf=false; //放开限制

			  }else{

				  postdata.ishandle=true; //标记上传完成
				  //获取处理的数据结果 
				  this.getsynresult();
				  this.uploadanimote.isdraf=false; //放开限制
							
			  }
	      }).catch((res) => {
	        	
	      });
	  },

	  
	  //标记处理上传完成
	  getsynresult() {
		  let allnums=this.uploadanimote.data.length; //获取总记录数

		  //获取已处理记录数
		  let handlenums=0;
		  this.uploadanimote.data.forEach(function(item,index) {
			  if(item.ishandle) {handlenums+=1;}
		  });
		  this.uploadanimote.percent=parseInt(handlenums/allnums*100); //更新任务完成百分比
		  if(this.uploadanimote.percent >= 100) { //任务完成时
			  clearInterval(this.uploadobj); //关闭定时器
			  this.uploadanimote.view=false; //关闭进度条窗口
			  this.uploadfile.dialog=false;  //关闭上传订单窗口
			  
			  this.getorderlists(); //刷新当前订单数据
		  }
	  },

	  
	  //批量导入订单到本地
	  ////////////////////////////////////////////////////////////////////////////

  },


}
</script>

</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 3% 1%}
.cz-pindd-order-infos-style2 {display:inline-block;width:100%;font-size:14px;}
.cz-pindd-order-infos-style2-span {display:inline-block;width:100%;font-size:12px;color:#999999;}
.cz-pindd-address {display:inline-block;font-size:13px;}

.tmall-order-goods {display:inline-block;width:100%;}
.tmall-order-goods-gift {position:absolute;font-size:12px;line-height:12px;color:#fff;background:red;right:0;top:0;padding:3px;border-radius:6px;}
.tmall-order-goods-img {float:left;width:65px;height:65px;border:1px solid rgba(221,221,221,.7);background:rgba(221,221,221,.3);border-radius:6px;display:flex;justify-content:center;align-items:center;position:relative;}
.tmall-order-goods-img img {border-radius:6px;max-width:100%;max-height:100%;}
.tmall-order-goods-name {float:left;width:calc(100% - 65px - 2px - 10px);line-height:23px;font-size:13px;}
.tmall-order-goods-spec {float:left;width:calc(100% - 65px - 2px - 10px);line-height:23px;font-size:12px;color:#999999}

.pindd-orders-upload-title {display:inline-block;font-size:13px;}
.pindd-orders-upload-title span {font-size:15px;font-weight:700;font-style:normal;color:#F56C6C;}

.cz-pindd-sell-show {display:flex;justify-content:center;align-items:center;background:rgba(211, 211, 211, 0.3);width:100%;height:200px;}
.cz-pindd-sell-show img {width:30px;height:30px}
.cz-pindd-sell-show span {font-size:13px;font-weight:500;margin-left:10px;letter-spacing:2px;}
</style>


// WEBPACK FOOTER //
// src/components/Pindd/Pinddorder.vue